interface ConfirmState {
  open: boolean
  title: string
  message: string
  confirmLabel: string | null
  resolve: ((value: boolean) => void) | null
}

export const useConfirm = () => {
  const state = useState<ConfirmState>('confirm-dialog', () => ({
    open: false,
    title: '',
    message: '',
    confirmLabel: null,
    resolve: null
  }))

  const confirm = (message: string, title = 'Are you sure?', confirmLabel?: string): Promise<boolean> => {
    return new Promise((resolve) => {
      state.value.title = title
      state.value.message = message
      state.value.confirmLabel = confirmLabel ?? null
      state.value.open = true
      state.value.resolve = resolve
    })
  }

  const onConfirm = () => {
    state.value.open = false
    state.value.resolve?.(true)
    state.value.resolve = null
  }

  const onCancel = () => {
    state.value.open = false
    state.value.resolve?.(false)
    state.value.resolve = null
  }

  return { state, confirm, onConfirm, onCancel }
}
